{
  "name": "calzedonia-productfeedback",
  "version": "4.0.1",
  "author": "Quix Srl",
  "homepage": "https://ionicframework.com/",
  "scripts": {
    "ng": "ng",
    "start": "npx ng serve --open",
    "start:qas": "npx ng serve --configuration=quality-app --open",
    "start:prod": "npx ng serve --configuration=production-app --open",
    "build": "npx ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "generate-ios-resources": "npx capacitor-assets generate --assetPath resources",
    "compodoc": "npx compodoc -p tsconfig.json src -s",
    "startProjectUi": "npx ng serve --disable-host-check --baseHref=/productfeedback/",
    "setup-env": "node scripts/environment.js",
    "build:prod": "ng build --configuration production",
    "build-ionic": "npx ionic capacitor build ios",
    "capacitor-sync": "npx ionic capacitor sync",
    "build-ionic-quality": "NODE_ENV=quality npm run setup-env && NODE_ENV=quality npx ionic capacitor run ios -c quality-app",
    "build-ionic-prod": "NODE_ENV=production npm run setup-env && NODE_ENV=production npx ionic capacitor run ios -c production-app",
    "generateLocalService": "openapi-generator-cli generate -g typescript-angular -i src/openapi/openapipf -o src/app/apiModule --skip-validate-spec --additional-properties npmName=@quix/productfeedback-api",
    "generateOpenapiLocalService": "rm -rf src/app/apiModule && openapi-generator-cli generate -g typescript-angular -i https://productfeedbackquality.calzedonia.com/oniverse-productfeedback/v3/api-docs/oniverse-app -o src/app/apiModule --skip-validate-spec --additional-properties npmName=@quix/productfeedback-api"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "~21.2.2",
    "@angular/cdk": "~21.2.1",
    "@angular/common": "~21.2.2",
    "@angular/core": "~21.2.2",
    "@angular/forms": "~21.2.2",
    "@angular/platform-browser": "~21.2.2",
    "@angular/platform-browser-dynamic": "~21.2.2",
    "@angular/router": "~21.2.2",
    "@capacitor-community/file-opener": "^7.0.1",
    "@capacitor/app": "^7.1.2",
    "@capacitor/core": "^7.6.0",
    "@capacitor/device": "^7.0.4",
    "@capacitor/filesystem": "^7.1.8",
    "@capacitor/ios": "^7.6.0",
    "@capacitor/preferences": "^7.0.4",
    "@capacitor/push-notifications": "^7.0.6",
    "@capacitor/splash-screen": "^7.0.5",
    "@capacitor/status-bar": "^7.0.5",
    "@ionic/angular": "^8.8.14",
    "@jsverse/transloco": "^7.5.0",
    "@ngrx/effects": "^21.0.1",
    "@ngrx/signals": "^21.0.1",
    "@ngrx/store": "^21.0.1",
    "@ngrx/store-devtools": "^21.0.1",
    "@sentry/angular": "^10.52.0",
    "@types/cordova-plugin-email-composer": "^0.0.34",
    "air-datepicker": "^3.6.0",
    "angular-oauth2-oidc": "^20.0.0",
    "angular-svg-icon": "^19.1.1",
    "bootstrap": "^5.3.3",
    "date-fns": "^3.6.0",
    "echarts": "^6.0.0",
    "pdfmake": "^0.3.7",
    "quang": "^21.0.1",
    "rxjs": "~7.8.2",
    "swiper": "^12.1.4",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "~21.2.1",
    "@angular/cli": "~21.2.1",
    "@angular/compiler": "^21.2.2",
    "@angular/compiler-cli": "~21.2.2",
    "@angular/language-service": "~21.2.2",
    "@capacitor/cli": "^7.6.0",
    "@commitlint/cli": "^19.8.0",
    "@commitlint/config-conventional": "^19.8.0",
    "@eslint/js": "^9.22.0",
    "@openapitools/openapi-generator-cli": "^2.7.0",
    "@trivago/prettier-plugin-sort-imports": "^5.2.2",
    "@types/node": "^22.13.10",
    "angular-eslint": "^21.1.0",
    "eslint": "^9.22.0",
    "eslint-config-love": "^117.0.0",
    "husky": "^9.1.7",
    "lint-staged": "^15.4.3",
    "ng-lint-staged": "^12.0.4",
    "ng-packagr": "^21.1.0",
    "prettier": "^3.5.3",
    "prettier-plugin-organize-attributes": "^1.0.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.26.1"
  },
  "overrides": {
    "@stencil/core": "4.12.2"
  },
  "description": "Product feedback"
}
